module.exports = __webpack_public_path__ + "cbea4914198990e3e33e5fc61a8d9f07.svg";